<template>
  <div class="spread">
    <div class="spread-warp">
      <div class="roomleft-num">取回列表</div>
      <div class="hist-list">
        <div class="csgo-tabs">
          <el-tabs type="border-card" v-model="activeName" @tab-click="getTab">
            <el-tab-pane label="取回中" name="one">
              <div class="csgo-table">
                <el-table :data="tableData" style="width: 100%">
                  <el-table-column prop="application_time" label="申请时间" width="180">
                  </el-table-column>
                  <el-table-column prop="skin_name" label="饰品名称">
                  </el-table-column>
                </el-table>
              </div>
            </el-tab-pane>
            <el-tab-pane label="取回成功" name="two">
              <div class="csgo-table">
                <el-table :data="tableData" style="width: 100%">
                  <el-table-column prop="application_time" label="申请时间" width="180">
                  </el-table-column>
                  <el-table-column prop="skin_name" label="饰品名称">
                  </el-table-column>
                </el-table>
              </div>
            </el-tab-pane>
            <el-tab-pane label="取回失败" name="three">
              <div class="csgo-table">
                <el-table :data="tableData" style="width: 100%">
                  <el-table-column prop="application_time" label="申请时间" width="180">
                  </el-table-column>
                  <el-table-column prop="skin_name" label="饰品名称">
                  </el-table-column>
                </el-table>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
        <div class="csgo-page">
          <el-pagination background :pager-count="5" layout="prev, pager, next" :total="searchForm.totalSize" :page-size="searchForm.limit" @current-change="currentChange">
          </el-pagination>
        </div>
      </div>
    </div>
    <div class="commonBg"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeName: 'one',
      tableData: [],
      searchForm: {
        status: 2,
        page: 1,
        totalSize: 0,
        limit: 20,
      },
    }
  },
  created() {
    this.getList();
  },
  methods: {
    getTab(tab) {
      if (tab.name == "one") {
        this.searchForm.status = 2
      } else if (tab.name == "two") {
        this.searchForm.status = 3
      } else {
        this.searchForm.status = 4
      }
      this.searchForm.page = 1
      this.getList()
    },
    getList() {
      this.$doGet('/api/member.Retrieve/list', this.searchForm).then((res) => {
        this.searchForm.totalSize = res.data.count
        this.tableData = res.data.list
      }).catch(() => { })
    },
    //分页 所有记录
    currentChange(value) {
      this.searchForm.page = value
      this.getList();
    }
  },
}
</script>

<style lang="less" scoped>
::v-deep .el-tabs__content {
  padding: 0 !important;
}
.spread {
  overflow: hidden;
  overflow-y: auto;
  width: 100%;
  height: 100%;
  max-width: 1500px;
  margin: auto;
  background: rgba(26, 28, 32, 0.9);

  .spread-warp {
    padding: 16px;
  }
  .roomleft-num {
    color: #c3c3e2;
    font-size: 20px;
    margin-bottom: 20px;
  }
}
</style>
